/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMvRefreshResponseDto } from '../../models/backend-mv-refresh-response-dto';

export interface RefreshAllEndpointAdminRefreshPost$Params {}

export function refreshAllEndpointAdminRefreshPost(
  http: HttpClient,
  rootUrl: string,
  params?: RefreshAllEndpointAdminRefreshPost$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendMvRefreshResponseDto>> {
  const rb = new RequestBuilder(rootUrl, refreshAllEndpointAdminRefreshPost.PATH, 'post');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendMvRefreshResponseDto>;
    }),
  );
}

refreshAllEndpointAdminRefreshPost.PATH = '/admin/refresh';
